import React from 'react';
import PropTypes from 'prop-types';

import MatchSheet from './MatchSheet';
import OrderOfPlay from './OrderOfPlay';

import { events } from '../../../../constants';

const ScheduleTabContent = (props) => {
    const { scheduleType, 'data-testid': dataTestId } = props;

    return (
        scheduleType === events.ORDER_OF_PLAY ? (
            <OrderOfPlay data-testid={dataTestId ? `${dataTestId}.order-of-play` : undefined} />
        ) : (
            <MatchSheet data-testid={dataTestId ? `${dataTestId}.match-sheet` : undefined} />
        )
    );
};

ScheduleTabContent.propTypes = {
    scheduleType: PropTypes.oneOf([events.ORDER_OF_PLAY, events.MATCH_SHEET]).isRequired,
};

export default ScheduleTabContent;
